import React from "react";
import InterviewVideo from "src/components/interview-video/InterviewVideo";

export default function InterviewVideoPage() {
  return <InterviewVideo />;
}
